import React, { useContext, useState } from 'react';
import { Button, Typography } from '@one-thd/sui-atomic-components';
import { UnsubscriptionModal } from '../EmailPreferences/UnsubscriptionModal';
import {
  unsubscribeFromAllEmail,
  unsubscribeFromAllEmailSuccess
} from '../../analytics/email';
import { addAnalyticEvent } from '../../analytics/common';
import { OptOutReasonFeedback } from '../OptOutReasonFeedback';
import { getSubscriptions, updateEmailPreferences } from '../../common/sharedFunctions';
import constants, { YES } from '../../constants/constants';
import { RETARGETING_TYPE } from '../tableData';
import { BannerContext, BannerProvider } from '../../contexts/BannerContext';
import ErrorBoundary from '../../contexts/ErrorBoundary';
import { ALL_EMAIL_UNSUBSCRIBE_SUCCESS } from '../../constants/bannerConstants';

function Preferences() {

  const {
    hideBanners,
    openSuccessAlert,
    openErrorAlert,
  } = useContext(BannerContext);

  const [unsubscribeToggle, setUnsubscribeToggle] = useState(false);
  const [selectedOptOuts, setSelectedOptOuts] = useState([]);
  const [emailAddress, setEmailAddress] = useState(null);

  const openUnsubscribeModal = () => {
    addAnalyticEvent(unsubscribeFromAllEmail);
    setUnsubscribeToggle(true);
    setSelectedOptOuts([]);
  };

  const handleUnsubCancel = () => {
    setUnsubscribeToggle(false);
  };

  const handleUnsubSuccess = (actualEmail, response, retrieveResponse) => {
    addAnalyticEvent(unsubscribeFromAllEmailSuccess);
    setEmailAddress(actualEmail);
    setUnsubscribeToggle(false);
    const subscriptions = getSubscriptions(retrieveResponse)
      .filter((sub) => sub.status === YES)
      .map((sub) => sub.type);
    setSelectedOptOuts(subscriptions.concat([RETARGETING_TYPE]));
    openSuccessAlert(ALL_EMAIL_UNSUBSCRIBE_SUCCESS, actualEmail);
  };

  const ignoreError = () => {};
  const handleOptOutReasonSuccess = () => {
    setSelectedOptOuts([]);
    hideBanners();
    openSuccessAlert(constants.UNSUB_REASON_SUCCESS);
  };

  const callApi = (subscriptions) => {

    updateEmailPreferences({
      emailAddress,
      subscriptions,
      table: null,
      callback: handleOptOutReasonSuccess,
      err: (err) => {
        if (err) {
          openErrorAlert(constants.OPTOUT_FEEDBACK_ERROR);
        }
      }
    });
  };

  return (
    <div className="sui-grid sui-gap-4">
      <OptOutReasonFeedback
        setSelectedOptOuts={setSelectedOptOuts}
        selectedOptOuts={selectedOptOuts}
        callApi={callApi}
      />
      <div className="sui-grid sui-grid-cols-1 sui-gap-4">
        <Typography variant="h2" weight="display">MARKETING EMAILS</Typography>
        <div>
          <Typography variant="body-base" height="none">
            To opt out of promotional emails from The Home Depot,
            click Opt Out of All Marketing Emails.
          </Typography>
        </div>
        <div className="sui-grid sui-grid-cols-8">
          <div className="hidden sm:sui-col-span-4 md:sui-col-span-5" />
          <div className="sui-col-span-8 sm:sui-col-span-4 md:sui-col-span-3">
            <Button variant="secondary" onClick={openUnsubscribeModal} fullWidth>
              Opt Out of All Marketing Emails
            </Button>
          </div>
        </div>
      </div>

      {unsubscribeToggle && (
        <UnsubscriptionModal
          handleClose={handleUnsubCancel}
          handleSuccess={handleUnsubSuccess}
          handleError={ignoreError}
        />
      )}
    </div>
  );
}

export function EmailUnsubscribePreferences() {
  return (
    <ErrorBoundary>
      <BannerProvider>
        <Preferences />
      </BannerProvider>
    </ErrorBoundary>
  );
}
